import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { UserRole } from "@models/role.model";
import { Tool } from "@app/tool/model/tool.model";
import { TranslateService } from "@ngx-translate/core";
import { TableComponent } from "@components/custom-table/table.component";

@Component({
    selector: 'app-tool-request-lines-tools-table',
    templateUrl: 'tool-request-lines-tools-table.html',
    styleUrls: ['tool-request-lines-tools-table.scss']
})
export class ToolRequestLinesToolsTableComponent {
    @ViewChild(TableComponent, {static: false}) table: TableComponent;
    @Input() tools = new Array<Tool>();
    @Input() replacementTools = new Array<Tool>();
    @Input() userRoles = new Array<UserRole>();
    @Input() userStates = new Array<any>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() treeMode = false;
    @Input() rowExpand = false;
    @Input() filter = true;
    @Input() tree = true;
    @Input() isMaterial = true;
    @Input() hasTitle = true;
    @Input() showFilters = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();

    @Output() replaceTool = new EventEmitter<any>();

    groupableColumns = [
        {id: 0, name: 'Part number', value: 'PartNumber'},
        {id: 1, name: 'Equipment', value: 'Equipment'},
        {id: 2, name: 'Line', value: 'Line'}];

    filterStatusList = [
        {name: 'All', value: 'All'},
        {name: 'Stored In Lift', value: 'STORED_IN_LIFT'},
        {name: 'At Atom Station', value: 'AT_ATOM_STATION'},
        {name: 'In Transport', value: 'IN_TRANSPORT'},
        {name: 'At Line', value: 'AT_LINE'},
        {name: 'At Facility', value: 'AT_FACILITY'},
    ];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
        });

    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {name: this.translateService.instant("generic.statuses.storedInLift"), value: 'STORED_IN_LIFT'},
            {name: this.translateService.instant("generic.statuses.atAtomStation"), value: 'AT_ATOM_STATION'},
            {name: this.translateService.instant("generic.statuses.inTransport"), value: 'IN_TRANSPORT'},
            {name: this.translateService.instant("generic.statuses.atLine"), value: 'AT_LINE'},
            {name: this.translateService.instant("generic.statuses.atFacility"), value: 'AT_FACILITY'},
        ];
    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    onToolReplace(event) {
        this.replaceTool.emit(event);
    }

    toggleExpand(expand: boolean) {
        this.table.onExpandAll(expand);
    }
}
